import { getStartOfDay } from "client/DateAndTime/dateTimeUtils";
import { getMillisecondsTillTomorrow } from "client_legacy/ndaw/dateFormatting";
import { useEffect, useState } from "react";
import { TimeZone } from "client/DateAndTime/timezones";

export type UseTodayOptions = {
	timezone: TimeZone;
};

export function useToday(options: UseTodayOptions): Date {
	const {
		timezone
	} = options;

	const [value, setValue] = useState<Date>(
		(): Date => {
			return getStartOfDay(
				new Date(),
				timezone
			);
		}
	);

	useEffect(
		(): (() => void) => {
			let handle: SetTimeoutHandle | undefined;
			const scheduleRefresh = (): void => {
				const msTillTomorrow: number = getMillisecondsTillTomorrow(timezone);

				handle = setTimeout(
					(): void => {
						const today = getStartOfDay(
							new Date(),
							timezone
						);
						setValue(today);

						scheduleRefresh();
					},
					msTillTomorrow
				);
			};

			scheduleRefresh();

			return () => clearTimeout(handle);
		},
		[timezone]
	);

	return value;
}
